module.exports = __webpack_public_path__ + "c96b93bd2e434a9786eb9cd6493cef2c.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-8.cur
// module id = 478
// module chunks = 0